// Contact Form component
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/CTAForm.css';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const CustomAlert = ({ show, onClose, message }) => {
    return (
      // Notification modal after message is sent to admin email
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: '#FBD430', color: 'black', border: 'none' }}
            onClick={onClose}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

export const ContactForm = () => {
  // Contact form structure and logic
  const form = useRef();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_mmsxiya', 'template_crkv29a', form.current, {
        publicKey: '3GlkvsbJk8N185FVM',
      })
      .then(
        () => {
            setAlertMessage('Message sent successfully!');
            setShowAlert(true);
          e.target.reset();
        },
        (error) => {
            setAlertMessage('Error: Message not sent!', error.text);
            setShowAlert(true);
        },
      );
  };

  return (
    <div className='contact-form'>
        <form ref={form} onSubmit={sendEmail} className="cta-form">
        <input type="text" name="from_name" placeholder="Enter your name"  className="cta-name" required/>
        <input type="email" name="from_email"  placeholder="Enter you email" className="cta-email" required/>
        <input type="text" name="message_subject" placeholder="Enter your subject" className="cta-subject" required/>
        <textarea type="text" name="message" placeholder="Enter message" className="cta-message" required/>
        <input type="submit" value="Submit" className="cta-submit-btn"/>
        </form>
        <CustomAlert
        show={showAlert}
        onClose={() => setShowAlert(false)}
        message={alertMessage}
        />
    </div>
  );
};